/** Match id when the user has an active collaboration chat socket joined (live chat open). */
let activeCollaborationChatMatchId: string | null = null;

export function setActiveCollaborationChatMatchId(matchId: string | null): void {
  activeCollaborationChatMatchId = matchId;
}

export function getActiveCollaborationChatMatchId(): string | null {
  return activeCollaborationChatMatchId;
}

export function isViewingCollaborationChat(matchId: string | undefined | null): boolean {
  if (!matchId || !activeCollaborationChatMatchId) return false;
  return activeCollaborationChatMatchId === matchId;
}
